export const REQUESTED = 'COACH_PROFILE_REQUESTED';
export const FAILED = 'COACH_PROFILE_FAILED';
export const SUCCESSFUL = 'COACH_PROFILE_SUCCESSFUL';
export const PROFILE_REQUESTED = 'GET_COACH_PROFILE_REQUESTED';
export const PROFILE_SUCCESSFUL = 'GET_COACH_PROFILE_SUCCESFUL';
export const PROFILE_FAILED = 'GET_COACH_PROFILE_FAILED';
export const SCHOOL_SEARCH = 'SCHOOL_SEARCH';
export const SESSION_VALID = 'SESSION_VALID';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const GET_COACH_FROM_DATABASE_REQUESTED = 'GET_COACH_FROM_DATABASE_REQUESTED';
export const GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTER = 'GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTER';
export const GET_COACH_FROM_DATABASE_FAILED = 'GET_COACH_FROM_DATABASE_FAILED';




// WEBPACK FOOTER //
// ./src/components/CoachRegistration/actionTypes.js